import { withAlpha } from "@/lib/color";
// AUTO-ESTRATTO da Mercato.jsx (refactor strutturale Fase 10.02) — nessun cambio di logica/UI/testid.
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import PlayerAvatar from "@/components/PlayerAvatar";
import { trPositionShort } from "@/lib/pesTranslations";
import { KIND_LABELS, KIND_COLORS, fmt, fmtDate } from "./constants";

export function TrasferimentiPanel({ user }) {
    const [windows, setWindows] = useState([]);
    const [deals, setDeals] = useState([]);
    const [inbox, setInbox] = useState([]);
    const [botOffers, setBotOffers] = useState([]);
    const [outbox, setOutbox] = useState([]);
    const [loading, setLoading] = useState(true);
    const [tab, setTab] = useState("feed");
    const [feedTeamFilter, setFeedTeamFilter] = useState("");

    const refresh = async () => {
        try {
            const [w, d, ib, ob, bo] = await Promise.all([
                api.get("/market/windows"),
                api.get("/market/deals"),
                user ? api.get("/market/deals/inbox").catch(() => ({ data: [] })) : Promise.resolve({ data: [] }),
                user ? api.get("/market/deals/outbox").catch(() => ({ data: [] })) : Promise.resolve({ data: [] }),
                user ? api.get("/bots/offers/inbox").catch(() => ({ data: { offers: [] } })) : Promise.resolve({ data: { offers: [] } }),
            ]);
            setWindows(w.data || []);
            setDeals(d.data || []);
            setInbox(ib.data || []);
            setOutbox(ob.data || []);
            setBotOffers((bo.data && bo.data.offers) || []);
            if (((ib.data || []).length > 0 || ((bo.data && bo.data.offers) || []).length > 0) && tab === "feed") {
                setTab("inbox");
            }
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    };

    /* eslint-disable */
    useEffect(() => {
        refresh();
    }, [user?.email]);
    /* eslint-enable */

    const openWindows = windows.filter((w) => w.status === "open");

    // Squadre coinvolte negli affari conclusi (compratore o venditore), ordinate per nome
    const feedTeams = Array.from(
        new Map(
            deals.flatMap((d) => [
                d.seller_team_id ? [d.seller_team_id, d.seller_team_name] : null,
                d.buyer_team_id ? [d.buyer_team_id, d.buyer_team_name] : null,
            ].filter(Boolean))
        ).entries()
    ).sort((a, b) => (a[1] || "").localeCompare(b[1] || ""));
    const feedDeals = feedTeamFilter
        ? deals.filter((d) => d.seller_team_id === feedTeamFilter || d.buyer_team_id === feedTeamFilter)
        : deals;

    return (
        <div data-testid="trasferimenti-panel">
            {/* Tabs (solo per presidenti) */}
            {user && user.team_id && (
                <div className="flex gap-1 mt-8 border-b border-t22252a" data-testid="mercato-tabs">
                    <TabBtn
                        active={tab === "feed"}
                        onClick={() => setTab("feed")}
                        testId="tab-feed"
                        label="Affari conclusi"
                        count={deals.length}
                    />
                    <TabBtn
                        active={tab === "inbox"}
                        onClick={() => setTab("inbox")}
                        testId="tab-inbox"
                        label="Ricevute"
                        count={inbox.length + botOffers.length}
                        accent="rgb(var(--tc-ff7a1a))"
                    />
                    <TabBtn
                        active={tab === "outbox"}
                        onClick={() => setTab("outbox")}
                        testId="tab-outbox"
                        label="Inviate"
                        count={outbox.length}
                        accent="rgb(var(--tc-2bb6ff))"
                    />
                </div>
            )}

            {/* Active windows (always shown) */}
            <section className="mt-8" data-testid="active-windows">
                <div className="op-label mb-3">// FINESTRE ATTIVE</div>
                {openWindows.length === 0 ? (
                    <div className="op-card p-5 text-t8f95a3 text-sm">
                        Nessuna finestra di mercato attualmente aperta.
                    </div>
                ) : (
                    <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
                        {openWindows.map((w) => (
                            <div key={w.id} className="op-card p-5" data-testid={`window-${w.id}`}>
                                <div className="op-label text-t2bb6ff">{w.kind?.toUpperCase()} · {w.season}</div>
                                <div className="op-heading text-2xl mt-2">{w.name}</div>
                                <div className="op-mono text-xs text-t8f95a3 mt-2">
                                    {fmtDate(w.start_date)} → {fmtDate(w.end_date)}
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </section>

            {/* Sezione condizionale in base al tab attivo (per i presidenti) */}
            {user && user.team_id && tab === "inbox" && (
                <section className="mt-10" data-testid="inbox-section">
                    {botOffers.length > 0 && (
                        <div className="mb-8" data-testid="bot-offers-section">
                            <div className="op-label mb-3" style={{ color: "rgb(var(--tc-e8222b))" }}>
                                // OFFERTE DALL&apos;ESTERO ({botOffers.length})
                            </div>
                            <div className="space-y-3">
                                {botOffers.map((o) => (
                                    <BotOfferRow key={o.id} offer={o} onChange={refresh} />
                                ))}
                            </div>
                        </div>
                    )}
                    <div className="op-label mb-3" style={{ color: "rgb(var(--tc-ff7a1a))" }}>
                        // OFFERTE RICEVUTE ({inbox.length})
                    </div>
                    {inbox.length === 0 ? (
                        <div className="op-card p-5 text-t8f95a3 text-sm">
                            Nessuna offerta ricevuta dalla tua squadra.
                        </div>
                    ) : (
                        <div className="space-y-3">
                            {inbox.map((d) => (
                                <DealRow key={d.id} deal={d} type="inbox" onChange={refresh} user={user} />
                            ))}
                        </div>
                    )}
                </section>
            )}

            {user && user.team_id && tab === "outbox" && (
                <section className="mt-10" data-testid="outbox-section">
                    <div className="op-label mb-3 text-t2bb6ff">
                        // OFFERTE INVIATE ({outbox.length})
                    </div>
                    {outbox.length === 0 ? (
                        <div className="op-card p-5 text-t8f95a3 text-sm">
                            {'Nessuna offerta inviata. Vai sulla pagina di una squadra avversaria e clicca "Offerta" su un giocatore.'}
                        </div>
                    ) : (
                        <div className="space-y-3">
                            {outbox.map((d) => (
                                <DealRow key={d.id} deal={d} type="outbox" onChange={refresh} user={user} />
                            ))}
                        </div>
                    )}
                </section>
            )}

            {/* Feed pubblico — mostrato sempre se utente non loggato, oppure se tab=feed */}
            {(!user || !user.team_id || tab === "feed") && (
                <section className="mt-10" data-testid="feed-section">
                    <div className="flex items-center justify-between gap-3 flex-wrap mb-3">
                        <div className="op-label">// AFFARI CONCLUSI</div>
                        {deals.length > 0 && (
                            <div className="flex items-center gap-2">
                                <select
                                    value={feedTeamFilter}
                                    onChange={(e) => setFeedTeamFilter(e.target.value)}
                                    className="bg-t0e1014 border border-t22252a text-tffffff op-mono text-[11px] px-2 py-1.5 max-w-[180px]"
                                    data-testid="feed-filter-team"
                                >
                                    <option value="">Tutte le squadre</option>
                                    {feedTeams.map(([id, name]) => <option key={id} value={id}>{name}</option>)}
                                </select>
                                {feedTeamFilter && (
                                    <button
                                        onClick={() => setFeedTeamFilter("")}
                                        className="op-mono text-[11px] text-t2bb6ff hover:underline"
                                        data-testid="feed-filter-reset"
                                    >
                                        Azzera
                                    </button>
                                )}
                            </div>
                        )}
                    </div>
                    {loading ? (
                        <div className="op-label text-t8f95a3 animate-pulse">// CARICAMENTO…</div>
                    ) : feedDeals.length === 0 ? (
                        <div className="op-card p-5 text-t8f95a3 text-sm">
                            {feedTeamFilter
                                ? "Nessun affare concluso per la squadra selezionata."
                                : "Nessun affare concluso. Quando un'offerta viene accettata, comparirà qui."}
                        </div>
                    ) : (
                        <div className="space-y-3">
                            {feedDeals.map((d) => (
                                <DealRow key={d.id} deal={d} type="feed" user={user} onChange={refresh} />
                            ))}
                        </div>
                    )}
                </section>
            )}
        </div>
    );
}

export function TabBtn({ active, onClick, label, count, testId, accent = "rgb(var(--tc-2bb6ff))" }) {
    return (
        <button
            onClick={onClick}
            className={`op-label px-4 py-3 border-b-2 transition-colors duration-150 ${
                active ? "text-tffffff" : "text-t8f95a3 hover:text-tffffff"
            }`}
            style={{ borderBottomColor: active ? accent : "transparent" }}
            data-testid={testId}
        >
            {label} {count > 0 && (
                <span className="op-mono text-[10px] ml-1" style={{ color: active ? accent : undefined }}>
                    ({count})
                </span>
            )}
        </button>
    );
}

export function BotOfferRow({ offer, onChange }) {
    const [busy, setBusy] = useState(false);
    const flag = offer.country === "arabia" ? "🇸🇦" : "🇨🇳";
    const act = async (action) => {
        if (action === "accept" && !confirm(`Accettare l'offerta di ${offer.country_label} per ${offer.player_name}? Il giocatore lascia il torneo (torna svincolato) e incassi ${fmt(offer.amount)}.`)) return;
        setBusy(true);
        try {
            await api.post(`/bots/offers/${offer.id}/${action}`);
            await onChange();
        } catch (e) {
            alert(e.response?.data?.detail || "Errore");
        } finally { setBusy(false); }
    };
    return (
        <div className="op-card p-4 flex flex-wrap items-center gap-4" data-testid={`bot-offer-${offer.id}`}
            style={{ borderColor: "rgb(var(--tc-e8222b) / 0.267)" }}>
            <PlayerAvatar src={offer.player_image} name={offer.player_name} size={44} />
            <div className="flex-1 min-w-[160px]">
                <div className="op-label text-[10px]" style={{ color: "rgb(var(--tc-e8222b))" }}>{flag} {offer.country_label}</div>
                <div className="text-tffffff font-semibold">{offer.player_name}</div>
                <div className="op-mono text-[11px] text-t8f95a3">{trPositionShort(offer.position)} · TM {fmt(offer.market_value)}</div>
            </div>
            <div className="text-right">
                <div className="op-mono text-lg text-t7ce38b font-bold" data-testid={`bot-offer-amount-${offer.id}`}>{fmt(offer.amount)}</div>
                <div className="op-mono text-[10px] text-tffb020">{offer.pct}% del TM</div>
            </div>
            <div className="flex gap-2">
                <button onClick={() => act("accept")} disabled={busy}
                    className="op-btn op-btn-primary text-sm" data-testid={`bot-offer-accept-${offer.id}`}
                    style={{ background: "rgb(var(--tc-7ce38b))", borderColor: "rgb(var(--tc-7ce38b))", color: "rgb(var(--tc-0b0d10))" }}>
                    Accetta
                </button>
                <button onClick={() => act("reject")} disabled={busy}
                    className="op-btn op-btn-ghost text-sm text-tff4d4d" data-testid={`bot-offer-reject-${offer.id}`}>
                    Rifiuta
                </button>
            </div>
        </div>
    );
}

export function DealRow({ deal, type, onChange, user }) {
    const [busy, setBusy] = useState(false);
    const [showAccept, setShowAccept] = useState(false);
    const [showCounter, setShowCounter] = useState(false);

    const kindColor = KIND_COLORS[deal.kind] || "rgb(var(--tc-8f95a3))";
    const kindLabel = KIND_LABELS[deal.kind] || deal.kind;
    const deferred = deal.status === "accepted" && deal.executed === false;
    const counters = deal.counter_history || [];
    const isBuyer = !!(user && user.team_id === deal.buyer_team_id);
    const lastCounter = counters.length > 0 ? counters[counters.length - 1] : null;

    const onReject = async () => {
        if (!window.confirm("Confermi di rifiutare questa offerta?")) return;
        setBusy(true);
        try {
            await api.post(`/market/deals/${deal.id}/reject`);
            onChange?.();
        } catch (e) {
            alert(e.response?.data?.detail || "Errore");
        } finally {
            setBusy(false);
        }
    };

    const onCancel = async () => {
        if (!window.confirm("Confermi di cancellare la tua offerta?")) return;
        setBusy(true);
        try {
            await api.delete(`/market/deals/${deal.id}`);
            onChange?.();
        } catch (e) {
            alert(e.response?.data?.detail || "Errore");
        } finally {
            setBusy(false);
        }
    };

    const onCancelDeferred = async () => {
        if (!window.confirm("Annullare questa operazione differita? Non verrà eseguita all'apertura del mercato e verrà inviata una notifica Telegram.")) return;
        setBusy(true);
        try {
            await api.post(`/market/deals/${deal.id}/cancel-deferred`);
            onChange?.();
        } catch (e) {
            alert(e.response?.data?.detail || "Errore");
        } finally {
            setBusy(false);
        }
    };

    const onCancelExecuted = async () => {
        if (!window.confirm(
            `Annullare questo trasferimento GIÀ ESEGUITO?\n\n` +
            `• ${deal.player_name} torna a ${deal.seller_team_name}\n` +
            (deal.counterparty_players?.length ? `• Le contropartite tornano a ${deal.buyer_team_name}\n` : "") +
            `• Il denaro spostato viene rimborsato\n\n` +
            `Verrà inviata una notifica pubblica Telegram. Confermi?`
        )) return;
        setBusy(true);
        try {
            const r = await api.post(`/market/deals/${deal.id}/cancel-executed`);
            const note = r.data?.had_snapshot
                ? "Ripristino completo eseguito."
                : "Ripristino best-effort eseguito (contratto reimpostato a 3 anni).";
            alert(`Trasferimento annullato. ${note}${r.data?.cash_refunded ? ` Rimborsati €${r.data.cash_refunded}M.` : ""}`);
            onChange?.();
        } catch (e) {
            alert(e.response?.data?.detail || "Errore");
        } finally {
            setBusy(false);
        }
    };

    return (
        <div
            className="op-card p-4 sm:p-5"
            style={{ borderLeft: `3px solid ${kindColor}` }}
            data-testid={`deal-row-${deal.id}`}
        >
            <div className="flex flex-wrap items-center justify-between gap-2 mb-3">
                <div className="flex items-center gap-2 flex-wrap">
                    <div
                        className="op-mono text-[10px] uppercase tracking-wider px-2 py-0.5 border leading-none"
                        style={{ color: kindColor, borderColor: withAlpha(kindColor, "66"), background: withAlpha(kindColor, "0F") }}
                        data-testid={`deal-kind-badge-${deal.id}`}
                    >
                        {kindLabel}
                    </div>
                    {deferred && (
                        <span
                            className="op-mono text-[9px] uppercase px-1.5 py-0.5 border"
                            style={{ color: "rgb(var(--tc-e8ff00))", borderColor: "rgb(var(--tc-e8ff00) / 0.4)", background: "rgb(var(--tc-e8ff00) / 0.059)" }}
                            data-testid={`deal-deferred-${deal.id}`}
                        >
                            {"⏳ In attesa · esegue all'apertura mercato"}
                        </span>
                    )}
                    {counters.length > 0 && deal.status === "pending" && (
                        <span
                            className="op-mono text-[9px] uppercase px-1.5 py-0.5 border"
                            style={{ color: "rgb(var(--tc-ff7a1a))", borderColor: "rgb(var(--tc-ff7a1a) / 0.4)", background: "rgb(var(--tc-ff7a1a) / 0.059)" }}
                            data-testid={`deal-negotiating-${deal.id}`}
                        >
                            🔄 Trattativa · {counters.length} controff.
                        </span>
                    )}
                </div>
                <div className="op-mono text-xs text-t8f95a3">
                    {fmtDate(deal.decided_at || deal.created_at)}
                </div>
            </div>

            {lastCounter && deal.status === "pending" && (
                <div
                    className="op-card p-2.5 mb-3 text-xs"
                    style={{ borderLeft: "2px solid rgb(var(--tc-ff7a1a))" }}
                    data-testid={`deal-last-counter-${deal.id}`}
                >
                    <span className="op-mono text-tff7a1a">Ultima controfferta · {lastCounter.by_team_name}</span>
                    {lastCounter.note && <span className="text-tc9ccd3"> — “{lastCounter.note}”</span>}
                </div>
            )}

            {/* MOBILE: giocatore in evidenza + flusso orizzontale chiaro DA → A */}
            <div className="sm:hidden">
                <div className="flex items-center gap-3 mb-2.5">
                    {deal.player_image ? (
                        <img
                            src={deal.player_image}
                            alt={deal.player_name}
                            className="w-12 h-12 rounded-full object-cover border-2 shrink-0"
                            style={{ borderColor: kindColor }}
                            data-testid={`deal-player-img-m-${deal.id}`}
                        />
                    ) : (
                        <div className="w-12 h-12 rounded-full flex items-center justify-center border-2 shrink-0 op-mono text-lg" style={{ borderColor: kindColor, color: kindColor }}>
                            {(deal.player_name || "?").charAt(0)}
                        </div>
                    )}
                    <div className="min-w-0">
                        {(deal.player_pes_id ?? deal.player_id) ? (
                            <Link
                                to={`/giocatori/${deal.player_pes_id ?? deal.player_id}`}
                                className="op-heading text-lg leading-tight truncate block hover:text-t2bb6ff transition-colors"
                                data-testid={`deal-player-link-m-${deal.id}`}
                            >
                                {deal.player_name}
                            </Link>
                        ) : (
                            <div className="op-heading text-lg leading-tight truncate">{deal.player_name}</div>
                        )}
                        <div className="op-mono text-xs text-t8f95a3">VG {deal.player_vg ?? "—"} · {trPositionShort(deal.player_position) || "—"}</div>
                    </div>
                </div>
                <div className="flex items-center gap-2 bg-t0c0e11 border border-t16181c rounded px-2.5 py-2">
                    <span className="op-label text-[9px] text-t5c6370 shrink-0">DA</span>
                    {deal.seller_logo && <img src={deal.seller_logo} alt="" className="w-6 h-6 object-contain shrink-0" />}
                    <Link to={`/squadre/${deal.seller_team_id}`} className="text-sm text-tffffff truncate min-w-0">{deal.seller_team_name}</Link>
                    <span className="op-mono text-lg font-bold px-1 shrink-0" style={{ color: kindColor }}>→</span>
                    <span className="op-label text-[9px] text-t5c6370 shrink-0">A</span>
                    {deal.buyer_logo && <img src={deal.buyer_logo} alt="" className="w-6 h-6 object-contain shrink-0" />}
                    <Link to={`/squadre/${deal.buyer_team_id}`} className="text-sm text-tffffff truncate min-w-0">{deal.buyer_team_name}</Link>
                </div>
            </div>

            {/* DESKTOP: griglia a 3 colonne */}
            <div className="hidden sm:grid sm:grid-cols-[1fr_auto_1fr] gap-3 items-center">
                {/* Seller */}
                <div className="flex items-center justify-end gap-2.5 text-right">
                    <div>
                        <div className="op-label">DA</div>
                        <Link
                            to={`/squadre/${deal.seller_team_id}`}
                            className="op-heading text-xl hover:text-t2bb6ff transition-colors"
                        >
                            {deal.seller_team_name}
                        </Link>
                    </div>
                    {deal.seller_logo && (
                        <img src={deal.seller_logo} alt="" className="w-10 h-10 object-contain shrink-0" data-testid={`deal-seller-logo-${deal.id}`} />
                    )}
                </div>
                {/* Arrow + player */}
                <div className="flex flex-col items-center text-center px-2">
                    {deal.player_image ? (
                        <img
                            src={deal.player_image}
                            alt={deal.player_name}
                            className="w-14 h-14 rounded-full object-cover border-2 mb-1"
                            style={{ borderColor: kindColor }}
                            data-testid={`deal-player-img-${deal.id}`}
                        />
                    ) : (
                        <div className="op-mono text-2xl" style={{ color: kindColor }}>→</div>
                    )}
                    {(deal.player_pes_id ?? deal.player_id) ? (
                        <Link
                            to={`/giocatori/${deal.player_pes_id ?? deal.player_id}`}
                            className="op-heading text-lg mt-0.5 hover:text-t2bb6ff transition-colors"
                            data-testid={`deal-player-link-${deal.id}`}
                        >
                            {deal.player_name}
                        </Link>
                    ) : (
                        <div className="op-heading text-lg mt-0.5">{deal.player_name}</div>
                    )}
                    <div className="op-mono text-xs text-t8f95a3">
                        VG {deal.player_vg ?? "—"} · {trPositionShort(deal.player_position) || "—"}
                    </div>
                </div>
                {/* Buyer */}
                <div className="flex items-center gap-2.5 text-left">
                    {deal.buyer_logo && (
                        <img src={deal.buyer_logo} alt="" className="w-10 h-10 object-contain shrink-0" data-testid={`deal-buyer-logo-${deal.id}`} />
                    )}
                    <div>
                        <div className="op-label">A</div>
                        <Link
                            to={`/squadre/${deal.buyer_team_id}`}
                            className="op-heading text-xl hover:text-t2bb6ff transition-colors"
                        >
                            {deal.buyer_team_name}
                        </Link>
                    </div>
                </div>
            </div>

            {/* Money + extras */}
            <div className="mt-4 flex flex-wrap gap-3 text-xs op-mono">
                {deal.kind === "loan_obligation" ? (
                    <>
                        <Chip
                            label="Totale operazione"
                            value={`€${fmt((deal.cash_amount || 0) + (deal.buyback_amount || 0))}`}
                            color="rgb(var(--tc-7ce38b))"
                        />
                        <Chip label="Cash subito" value={`€${fmt(deal.cash_amount)}`} color="rgb(var(--tc-2bb6ff))" />
                        {deal.buyback_amount > 0 && (
                            <Chip label="Riscatto (obbligo)" value={`€${fmt(deal.buyback_amount)}`} color="rgb(var(--tc-ff7a1a))" />
                        )}
                    </>
                ) : (
                    <>
                        <Chip label="Cash" value={`€${fmt(deal.cash_amount)}`} color="rgb(var(--tc-2bb6ff))" />
                        {deal.buyback_amount > 0 && (
                            <Chip
                                label={deal.kind === "loan_option" ? "Riscatto (opzione)" : "Riscatto"}
                                value={`€${fmt(deal.buyback_amount)}`}
                                color="rgb(var(--tc-ff7a1a))"
                            />
                        )}
                    </>
                )}
                {(deal.counterparty_players || []).length > 0 && (
                    <Chip
                        label={`+${deal.counterparty_players.length} contropartit${deal.counterparty_players.length === 1 ? "a" : "e"}`}
                        value={deal.counterparty_players.map((p) => p.name).join(", ")}
                        color="rgb(var(--tc-8f95a3))"
                    />
                )}
                {deal.kind !== "transfer" && deal.wage_split && (
                    <Chip
                        label="Stipendio"
                        value={`Compratore ${deal.wage_split.buyer_pct}% / Venditore ${deal.wage_split.seller_pct}%`}
                        color="rgb(var(--tc-8f95a3))"
                    />
                )}
                {deal.kind !== "loan" && (
                    <Chip label="Contratto" value={`${deal.contract_years} anni`} color="rgb(var(--tc-8f95a3))" />
                )}
            </div>

            {/* Admin: annulla operazione differita (accettata, non ancora eseguita) */}
            {deferred && user?.role === "admin" && (
                <div className="mt-4" data-testid={`deferred-admin-${deal.id}`}>
                    <button
                        className="op-btn text-sm border-tff4d4d text-tff4d4d hover:bg-tff4d4d/10"
                        onClick={onCancelDeferred}
                        disabled={busy}
                        data-testid={`cancel-deferred-${deal.id}`}
                    >
                        ❌ Annulla operazione
                    </button>
                </div>
            )}

            {/* Admin: annulla un trasferimento GIÀ ESEGUITO (ripristino giocatori + denaro) */}
            {!deferred && deal.executed && deal.status === "accepted" && user?.role === "admin" && (
                <div className="mt-4" data-testid={`executed-admin-${deal.id}`}>
                    <button
                        className="op-btn text-sm border-tff4d4d text-tff4d4d hover:bg-tff4d4d/10"
                        onClick={onCancelExecuted}
                        disabled={busy}
                        data-testid={`cancel-executed-${deal.id}`}
                    >
                        ↩️ Annulla trasferimento (ripristina)
                    </button>
                </div>
            )}

            {/* Inbox actions */}
            {type === "inbox" && deal.status === "pending" && (                <>
                    <div className="mt-4 flex flex-wrap gap-2">
                        <button
                            className="op-btn op-btn-primary"
                            onClick={() => setShowAccept(true)}
                            disabled={busy}
                            data-testid={`accept-${deal.id}`}
                        >
                            Accetta
                        </button>
                        <button
                            className="op-btn"
                            onClick={() => setShowCounter(true)}
                            disabled={busy}
                            style={{ borderColor: "rgb(var(--tc-ff7a1a) / 0.4)", color: "rgb(var(--tc-ff7a1a))" }}
                            data-testid={`counter-${deal.id}`}
                        >
                            Controfferta
                        </button>
                        <button
                            className="op-btn"
                            onClick={onReject}
                            disabled={busy}
                            data-testid={`reject-${deal.id}`}
                        >
                            Rifiuta
                        </button>
                    </div>
                    {showAccept && (
                        <AcceptModal
                            deal={deal}
                            onClose={() => setShowAccept(false)}
                            onDone={() => {
                                setShowAccept(false);
                                onChange?.();
                            }}
                        />
                    )}
                    {showCounter && (
                        <CounterModal
                            deal={deal}
                            onClose={() => setShowCounter(false)}
                            onDone={() => {
                                setShowCounter(false);
                                onChange?.();
                            }}
                        />
                    )}
                </>
            )}

            {/* Outbox: in attesa di risposta dell'altra parte */}
            {type === "outbox" && deal.status === "pending" && (
                <div className="mt-4 flex items-center justify-between gap-2 flex-wrap">
                    <span className="op-mono text-xs text-t8f95a3">
                        In attesa di risposta di {deal.awaiting === deal.seller_team_id ? deal.seller_team_name : deal.buyer_team_name}…
                    </span>
                    {isBuyer && (
                        <button
                            className="op-btn"
                            onClick={onCancel}
                            disabled={busy}
                            data-testid={`cancel-${deal.id}`}
                        >
                            Annulla offerta
                        </button>
                    )}
                </div>
            )}
        </div>
    );
}

export function Chip({ label, value, color }) {
    return (
        <span
            className="inline-flex items-center gap-1.5 px-2 py-1 border"
            style={{ borderColor: `${withAlpha(color, "40")}`, color }}
        >
            <span className="opacity-60">{label}:</span>
            <span className="text-tffffff">{value}</span>
        </span>
    );
}

export function AcceptModal({ deal, onClose, onDone }) {
    const cps = deal.counterparty_players || [];
    // Il venditore riceve le contropartite → è lui a decidere i loro contratti.
    const isSellerSide = deal.awaiting === deal.seller_team_id;
    const setsContracts = isSellerSide && cps.length > 0;
    const [years, setYears] = useState(() => {
        const init = {};
        const existing = deal.counterparty_contract_years || {};
        cps.forEach((cp) => (init[cp.player_id] = existing[cp.player_id] || 3));
        return init;
    });
    const [busy, setBusy] = useState(false);
    const [err, setErr] = useState(null);

    const submit = async () => {
        setBusy(true);
        setErr(null);
        try {
            const body = {};
            if (setsContracts) body.counterparty_contract_years = years;
            await api.post(`/market/deals/${deal.id}/accept`, body);
            onDone();
        } catch (e) {
            setErr(e.response?.data?.detail || "Errore");
        } finally {
            setBusy(false);
        }
    };

    return (
        <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur p-4"
            data-testid="accept-modal"
        >
            <div className="op-card max-w-md w-full p-5">
                <div className="op-label mb-2" style={{ color: "rgb(var(--tc-ff7a1a))" }}>// ACCETTA OFFERTA</div>
                <div className="op-heading text-xl mb-3">{deal.player_name} → {deal.buyer_team_name}</div>
                {cps.length === 0 ? (
                    <p className="text-sm text-tc9ccd3">
                        {"Nessuna contropartita. Confermando, l'affare è concluso: se il mercato è aperto viene eseguito subito, altrimenti giocatore e denaro si spostano all'apertura della prossima finestra."}
                    </p>
                ) : setsContracts ? (
                    <>
                        <p className="text-sm text-tc9ccd3 mb-3">
                            Hai ricevuto {cps.length} contropartit{cps.length === 1 ? "a" : "e"}. Scegli la
                            <span className="text-t2bb6ff"> durata del contratto</span> per ognuna (1–5 anni):
                        </p>
                        <div className="space-y-3">
                            {cps.map((cp) => (
                                <div key={cp.player_id} className="flex items-center justify-between gap-3">
                                    <div className="flex-1 min-w-0">
                                        <div className="text-tffffff text-sm font-semibold truncate">{cp.name}</div>
                                        <div className="op-mono text-xs text-t8f95a3">VG {cp.vg ?? "—"} · {trPositionShort(cp.position) || "—"}</div>
                                    </div>
                                    <select
                                        className="op-input w-20"
                                        value={years[cp.player_id] || 1}
                                        onChange={(e) => setYears({ ...years, [cp.player_id]: parseInt(e.target.value, 10) })}
                                        data-testid={`years-${cp.player_id}`}
                                    >
                                        {[1, 2, 3, 4, 5].map((y) => (
                                            <option key={y} value={y}>{y} {y === 1 ? "anno" : "anni"}</option>
                                        ))}
                                    </select>
                                </div>
                            ))}
                        </div>
                    </>
                ) : (
                    <>
                        <p className="text-sm text-tc9ccd3 mb-2" data-testid="accept-cps-readonly">
                            L&apos;affare include {cps.length} contropartit{cps.length === 1 ? "a" : "e"} che
                            {" "}<span className="text-t2bb6ff">vanno a {deal.seller_team_name}</span>: il loro
                            contratto lo decide chi le riceve, non tu.
                        </p>
                        <div className="space-y-1">
                            {cps.map((cp) => (
                                <div key={cp.player_id} className="op-mono text-xs text-t8f95a3">
                                    {cp.name} <span className="text-t5c6370">(VG {cp.vg ?? "—"} · {trPositionShort(cp.position) || "—"})</span>
                                </div>
                            ))}
                        </div>
                    </>
                )}

                {err && <div className="op-card p-3 mt-3 text-sm text-tff4d4d border-tff4d4d/40">{err}</div>}

                <div className="flex justify-end gap-2 mt-5">
                    <button className="op-btn" onClick={onClose} disabled={busy} data-testid="modal-cancel">
                        Annulla
                    </button>
                    <button
                        className="op-btn op-btn-primary"
                        onClick={submit}
                        disabled={busy}
                        data-testid="modal-confirm-accept"
                    >
                        {busy ? "Esecuzione…" : "Conferma e Accetta"}
                    </button>
                </div>
            </div>
        </div>
    );
}

export function CounterModal({ deal, onClose, onDone }) {
    // Chi risponde può cambiare anche il TIPO di operazione.
    const [kind, setKind] = useState(deal.kind || "transfer");
    const isLoanSecco = kind === "loan";
    const hasBuyback = kind === "loan_obligation" || kind === "loan_option";
    // Chi risponde: il venditore riceve le contropartite (→ ne decide i contratti),
    // il compratore riceve il giocatore principale (→ ne decide il contratto).
    const isSellerSide = deal.awaiting === deal.seller_team_id;
    const isBuyerSide = !isSellerSide;
    const [cashMln, setCashMln] = useState(((deal.cash_amount || 0) / 1_000_000).toString());
    const [years, setYears] = useState(deal.contract_years || 3);
    const [buybackMln, setBuybackMln] = useState(((deal.buyback_amount || 0) / 1_000_000).toString());
    const [note, setNote] = useState("");
    const [busy, setBusy] = useState(false);
    const [err, setErr] = useState(null);
    // Contropartite (giocatori del COMPRATORE inclusi nell'affare)
    const [cps, setCps] = useState(deal.counterparty_players || []);
    const [cpYears, setCpYears] = useState(() => {
        const init = {};
        const existing = deal.counterparty_contract_years || {};
        (deal.counterparty_players || []).forEach((c) => (init[c.player_id] = existing[c.player_id] || 3));
        return init;
    });
    const [buyerRoster, setBuyerRoster] = useState([]);
    const [addId, setAddId] = useState("");

    useEffect(() => {
        api.get(`/teams/${deal.buyer_team_id}/roster`)
            .then((r) => setBuyerRoster((r.data?.roster || []).filter((p) => !p.is_loaned_out)))
            .catch(() => setBuyerRoster([]));
    }, [deal.buyer_team_id]);

    const addCp = () => {
        if (!addId) return;
        const p = buyerRoster.find((r) => r.entry_id === addId);
        if (!p) return;
        if (cps.some((c) => c.player_id === addId)) { setAddId(""); return; }
        setCps([...cps, { player_id: p.entry_id, name: p.name, vg: p.vg, position: p.position, is_ugly: p.is_ugly }]);
        setCpYears((y) => ({ ...y, [p.entry_id]: y[p.entry_id] || 3 }));
        setAddId("");
    };
    const removeCp = (pid) => {
        setCps(cps.filter((c) => c.player_id !== pid));
        setCpYears((y) => { const n = { ...y }; delete n[pid]; return n; });
    };

    const submit = async () => {
        const cash = Math.round(parseFloat(cashMln || "0") * 1_000_000);
        if (isNaN(cash) || cash < 0) { setErr("Inserisci una cifra valida (in milioni)."); return; }
        const body = {
            kind,
            cash_amount: cash,
            note,
            counterparty_players: cps.map((c) => ({ player_id: c.player_id, name: c.name })),
        };
        // Il contratto del giocatore principale lo decide solo il compratore (no prestito secco).
        if (isBuyerSide && !isLoanSecco) body.contract_years = parseInt(years, 10);
        // I contratti delle contropartite li decide solo il venditore (che le riceve).
        if (isSellerSide) {
            const map = {};
            cps.forEach((c) => (map[c.player_id] = cpYears[c.player_id] || 3));
            body.counterparty_contract_years = map;
        }
        body.buyback_amount = hasBuyback ? Math.round(parseFloat(buybackMln || "0") * 1_000_000) : 0;
        setBusy(true); setErr(null);
        try {
            await api.post(`/market/deals/${deal.id}/counter`, body);
            onDone();
        } catch (e) {
            setErr(e.response?.data?.detail || "Errore");
        } finally {
            setBusy(false);
        }
    };

    const availableToAdd = buyerRoster.filter((p) => !cps.some((c) => c.player_id === p.entry_id));

    return (
        <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur p-4"
            data-testid="counter-modal"
        >
            <div className="op-card max-w-md w-full p-5 max-h-[90vh] overflow-y-auto">
                <div className="op-label mb-2" style={{ color: "rgb(var(--tc-ff7a1a))" }}>// CONTROFFERTA</div>
                <div className="op-heading text-xl mb-1">{deal.player_name}</div>
                <p className="text-sm text-t8f95a3 mb-4">
                    {deal.seller_team_name} → {deal.buyer_team_name}.{" "}
                    {"Rilancia le condizioni: la palla passerà all'altra squadra."}
                </p>

                <label className="op-label text-[10px] text-t8f95a3">TIPO OPERAZIONE</label>
                <select
                    className="op-input w-full mt-1 mb-3"
                    value={kind}
                    onChange={(e) => setKind(e.target.value)}
                    data-testid="counter-kind-select"
                >
                    <option value="transfer">Trasferimento definitivo</option>
                    <option value="loan">Prestito secco</option>
                    <option value="loan_obligation">Prestito + obbligo di riscatto</option>
                    <option value="loan_option">Prestito + diritto di riscatto</option>
                </select>

                <label className="op-label text-[10px] text-t8f95a3">CASH RICHIESTO (in milioni)</label>
                <input
                    type="number" step="0.1" min="0"
                    className="op-input w-full mt-1 mb-3"
                    value={cashMln}
                    onChange={(e) => setCashMln(e.target.value)}
                    data-testid="counter-cash-input"
                />

                {/* Durata contratto giocatore principale: la decide SOLO il compratore */}
                {!isLoanSecco && isBuyerSide && (
                    <>
                        <label className="op-label text-[10px] text-t8f95a3">DURATA CONTRATTO</label>
                        <select
                            className="op-input w-full mt-1 mb-3"
                            value={years}
                            onChange={(e) => setYears(parseInt(e.target.value, 10))}
                            data-testid="counter-years-input"
                        >
                            {[1, 2, 3, 4, 5].map((y) => (
                                <option key={y} value={y}>{y} {y === 1 ? "anno" : "anni"}</option>
                            ))}
                        </select>
                    </>
                )}
                {!isLoanSecco && isSellerSide && (
                    <div className="op-mono text-[11px] text-t5c6370 mb-3" data-testid="counter-years-readonly">
                        Contratto {deal.player_name}: {deal.contract_years} anni · lo decide il compratore.
                    </div>
                )}

                {hasBuyback && (
                    <>
                        <label className="op-label text-[10px] text-t8f95a3">
                            {kind === "loan_obligation" ? "CIFRA RISCATTO OBBLIGATORIO (in milioni)" : "CIFRA RISCATTO OPZIONALE (in milioni)"}
                        </label>
                        <input
                            type="number" step="0.1" min="0"
                            className="op-input w-full mt-1 mb-3"
                            value={buybackMln}
                            onChange={(e) => setBuybackMln(e.target.value)}
                            data-testid="counter-buyback-input"
                        />
                    </>
                )}

                {/* Contropartite (giocatori del compratore). I contratti li imposta SOLO il venditore */}
                <label className="op-label text-[10px] text-t8f95a3">
                    CONTROPARTITE · giocatori di {deal.buyer_team_name}
                    {isSellerSide && <span className="text-t2bb6ff"> · scegli i contratti</span>}
                </label>
                <div className="mt-1 mb-2 space-y-1" data-testid="counter-cps-list">
                    {cps.length === 0 ? (
                        <div className="op-mono text-[11px] text-t5c6370">Nessuna contropartita.</div>
                    ) : cps.map((c) => (
                        <div key={c.player_id} className="flex items-center justify-between gap-2 bg-t0c0e11 border border-t22252a px-2 py-1" data-testid={`counter-cp-${c.player_id}`}>
                            <span className="text-xs text-tffffff min-w-0 truncate">{c.name} {c.is_ugly && <span className="text-tff7a1a">[UGLY]</span>} <span className="text-t5c6370">(VG {c.vg ?? "—"} · {trPositionShort(c.position) || "—"})</span></span>
                            <div className="flex items-center gap-2 flex-shrink-0">
                                {isSellerSide && (
                                    <select
                                        className="op-input op-input-sm w-16 text-xs py-0.5"
                                        value={cpYears[c.player_id] || 3}
                                        onChange={(e) => setCpYears((y) => ({ ...y, [c.player_id]: parseInt(e.target.value, 10) }))}
                                        data-testid={`counter-cp-years-${c.player_id}`}
                                    >
                                        {[1, 2, 3, 4, 5].map((yy) => (
                                            <option key={yy} value={yy}>{yy}a</option>
                                        ))}
                                    </select>
                                )}
                                <button
                                    type="button"
                                    onClick={() => removeCp(c.player_id)}
                                    className="op-label text-[9px] px-2 py-0.5 border border-tff4d4d text-tff4d4d"
                                    data-testid={`counter-cp-remove-${c.player_id}`}
                                >
                                    ✕ Togli
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
                <div className="flex gap-2 mb-3">
                    <select
                        className="op-input flex-1"
                        value={addId}
                        onChange={(e) => setAddId(e.target.value)}
                        data-testid="counter-cp-select"
                    >
                        <option value="">+ Aggiungi contropartita…</option>
                        {availableToAdd.map((p) => (
                            <option key={p.entry_id} value={p.entry_id}>
                                {p.name} {p.is_ugly ? "[UGLY] " : ""}(VG {p.vg ?? "—"} · {trPositionShort(p.position) || "—"})
                            </option>
                        ))}
                    </select>
                    <button
                        type="button"
                        onClick={addCp}
                        disabled={!addId}
                        className="op-btn disabled:opacity-50"
                        data-testid="counter-cp-add"
                    >
                        Aggiungi
                    </button>
                </div>

                <label className="op-label text-[10px] text-t8f95a3">MESSAGGIO (opzionale)</label>
                <textarea
                    className="op-input w-full mt-1"
                    rows={2}
                    value={note}
                    onChange={(e) => setNote(e.target.value)}
                    placeholder="es. Accetto ma voglio anche il vostro centrocampista"
                    data-testid="counter-note-input"
                />

                {err && <div className="op-card p-3 mt-3 text-sm text-tff4d4d border-tff4d4d/40">{err}</div>}

                <div className="flex justify-end gap-2 mt-5">
                    <button className="op-btn" onClick={onClose} disabled={busy} data-testid="counter-cancel">
                        Annulla
                    </button>
                    <button
                        className="op-btn op-btn-primary"
                        onClick={submit}
                        disabled={busy}
                        data-testid="counter-confirm"
                    >
                        {busy ? "Invio…" : "Invia controfferta"}
                    </button>
                </div>
            </div>
        </div>
    );
}


// -------------- VETRINA (showcase) --------------
